import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { useMemo, useState } from "react"

export const TEMPLATE_GROUP_LABELS = {
  account: "This account",
  default: "Default templates",
}

const TEMPLATE_GROUP_ORDER = {
  account: 0,
  default: 1,
}

export function templateGroupKey(option) {
  if (option?.is_global || option?.template_group === "default") {
    return "default"
  }
  return "account"
}

export function templateGroupLabel(option) {
  return TEMPLATE_GROUP_LABELS[templateGroupKey(option)]
}

export function sortTemplatesForGroupedSelect(templates) {
  return [...templates].sort((a, b) => {
    const groupDiff =
      (TEMPLATE_GROUP_ORDER[templateGroupKey(a)] ?? 0) -
      (TEMPLATE_GROUP_ORDER[templateGroupKey(b)] ?? 0)
    if (groupDiff) return groupDiff
    return String(a.name || a.label || "").localeCompare(
      String(b.name || b.label || "")
    )
  })
}

export function optionsForTemplateTab(templates, tab) {
  return sortTemplatesForGroupedSelect(
    templates.filter((item) => templateGroupKey(item) === tab)
  )
}

export function useTemplatePickerTab(templates) {
  const [tab, setTab] = useState("account")
  const options = useMemo(
    () => optionsForTemplateTab(templates, tab),
    [templates, tab]
  )
  return { tab, setTab, options }
}

export function TemplateGroupTabs({ tab, onChange }) {
  return (
    <Tabs
      value={tab}
      onChange={(_, value) => onChange(value)}
      variant="fullWidth"
      sx={{ minHeight: 40, mb: 0.5 }}
    >
      <Tab
        value="account"
        label={TEMPLATE_GROUP_LABELS.account}
        sx={{ textTransform: "none", minHeight: 40 }}
      />
      <Tab
        value="default"
        label={TEMPLATE_GROUP_LABELS.default}
        sx={{ textTransform: "none", minHeight: 40 }}
      />
    </Tabs>
  )
}
